<script>
    import { game } from '../store/store';
    export let playerOb;
</script>

<li>
    <div class="player-name">
        {playerOb.name}
    </div>
    <div class="score">
        {playerOb.score}
    </div>    
</li>

<style>
li {
    margin-top: 0.5em;
    list-style: none;
    border-left: 1em solid var(--player-color, inherite);
    padding-left: 0.5em;
}

.player-name {
    display: inline-block;
    min-width: 5em;
    text-align: left;
    font-size: 1em;
}
.score {
    display: inline-block;
    min-width: 3em;
    text-align: right;
    font-size: 1.5em;
}

@media only screen and (min-width: 1000px) {
    li {
        margin-top: 1.5em;
    }

}

</style>